/**
 * Shared utilities for batch/weight conversion used across end-of-shift steps.
 * Centralised here so rounding behaviour is consistent everywhere.
 */

/** Rounds to 3 decimal places — used for batch display values. */
export const toBatch = (qty: number, outputQty: number | null | undefined): number | null => {
  if (!outputQty || outputQty <= 0) return null
  return Math.round((qty / outputQty) * 1000) / 1000
}

/** Converts a batch value to base-unit weight, rounded to 4 decimal places for API submission. */
export const batchToWeight = (batch: number, outputQty: number): number =>
  Math.round(batch * outputQty * 10000) / 10000

/** Converts a base-unit weight to a batch display value, rounded to 3 decimal places. */
export const weightToBatch = (weight: number, outputQty: number): number =>
  Math.round((weight / outputQty) * 1000) / 1000

/**
 * Tolerance for float equality checks on quantities coming from the API.
 * Avoids false positives when e.g. 2.2 is stored as 2.2000000001.
 */
const FLOAT_EPSILON = 0.001

export const floatsEqual = (a: number, b: number): boolean =>
  Math.abs(a - b) < FLOAT_EPSILON
